/** 会员信息API */
import type { Api } from '@/typings/api';
import { post, upload } from '../../request';
const prefix = '/store/memberInfo';
/**
 * 分页查询会员信息
 *
 * @param params 查询参数
 */
export const findPage: Api.CommonMethods.FindPage<Api.Store.MemberInfo> = params => {
  return post(`${prefix}/findPage`, params);
};
/**
 * 查询会员信息列表
 *
 * @param params 查询参数
 */
export const findAll: Api.CommonMethods.FindAll<Api.Store.MemberInfo> = params => {
  return post(`${prefix}/findAll`, params);
};
/**
 * 查询单个会员信息
 *
 * @param id 会员信息ID
 * @param column 查询字段
 */
export const findOne: Api.CommonMethods.FindOne<Api.Store.MemberInfo> = (id: string, column?: string[]) => {
  return post(`${prefix}/findOne`, { id, column });
};
/**
 * 保存会员信息
 *
 * @param params 会员信息信息
 */
export const doSave: Api.CommonMethods.Save = params => {
  return post(`${prefix}/save`, params);
};
/**
 * 更新会员信息信息
 *
 * @param params 会员信息信息
 */
export const doUpdate: Api.CommonMethods.Update = params => {
  return post(`${prefix}/update`, params);
};
/**
 * 删除会员信息
 *
 * @param id 会员信息ID
 */
export const doDelete: Api.CommonMethods.Delete = id => {
  return post(`${prefix}/delete?id=${id}`);
};
/**
 * 批量删除会员信息
 *
 * @param ids 会员信息ID数组
 */
export const doBatchDelete: Api.CommonMethods.BatchDelete = ids => {
  return post(`${prefix}/deleteList`, { ids });
};

/**
 * 导入
 *
 * @param file 文件
 * @param params
 * @returns
 */
export const doImport = (file: File, params: Api.Common.ImportParams = { isCustom: true }) => {
  return upload(`${prefix}/import`, file, params);
};

export default {
  findPage,
  findOne,
  doSave,
  doUpdate,
  doDelete,
  doBatchDelete
};
